import { render } from "./App.vue?vue&type=template&id=3e884bb4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3e884bb4&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__